import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import "./apropos.css";
import { baseApiUrl } from "../../../services/api";
function Apropos() {
  const [bureauMembers, setBureauMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBureauMembers = async () => {
      try {
        setLoading(true);
        const response = await baseApiUrl.get('/membre-bureau');

        if (response.status !== 200) {
          throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = response.data;

        if (!data || data.length === 0) {
          console.warn("Aucun membre trouvé.");
        }

        setBureauMembers(data);
        setLoading(false);
      } catch (err) {
        console.error('Erreur lors du chargement des membres:', err.message || err);
        setError("Erreur lors de la récupération des membres du bureau.");
        setLoading(false);
      }
    };

    fetchBureauMembers();
  }, []);
  const keyInfoCards = [
    {
      title: "Nos perspectives majeures",
      content: [
        "La création d'un centre national des technologies, inventions et innovations (CNTII) devant abriter son siège",
        "La création et institutionnalisation d'un cadre de concertation nationale technique des inventeurs et innovateurs (CCNTII)",
        "La mise en place d'un fonds d'appui au développement des prototypes innovants",
        "La création d'unités de transformation et de conservation des produits du maraîchage dans les régions à forte production",
        "La création d'une ferme aquacole",
        "L'organisation de voyages d'études thématiques pour le renforcement des capacités techniques des inventeurs et innovateurs",
      ],
      icon: "fa-lightbulb",
    },
    {
      title: "Nos objectifs",
      content: [
        "Aider les inventeurs et innovateurs à mener à bien leurs activités",
        "Créer une entre-aide entre les membres",
        "Promouvoir et vulgariser les résultats des travaux des inventeurs et innovateurs",
        "Aider aux transferts des technologies créées par nos membres vers le monde rural",
        "Concevoir et mettre en œuvre de projets dans nos domaines de compétences",
        "Contribuer à la création de l'emploi",
        "Représenter les inventeurs et innovateurs dans des rencontres nationales et internationales",
      ],
      icon: "fa-bullseye",
    },
    {
      title: "Nos domaines",
      content: [
        "Assainissement",
        "Énergie-Energie renouvelable-hydraulique",
        "Équipement pour le secteur agro sylvo-pastoral",
        "Produits de la transformation agro sylvo-pastorale",
        "Santé et connaissance endogène",
        "L'art vestimentaire (Faso Danfani et COCO DONDA)",
        "L'art culinaire local",
        "Intrants agricoles (semences, engrais, pesticides)",
        "Secteur du numérique (Digital ; I A)",
        "Services",
      ],
      icon: "fa-globe",
    },
    {
      title: "Nos missions",
      content: [
        "Contribuer à l'émergence du Burkina Faso à travers la valorisation des technologies innovantes mises au point par ses membres",
        "Faire du monde rural un levier de développement",
        "Faire de l'association un organe consultatif",
      ],
      icon: "fa-rocket",
    },
    // {
    //   title: "Nos contacts",
    //   content: [
    //     "Télephone: +226 70 00 35 55",
    //     "Email: ab2iburkinafaso@gmail.com"
    //   ],
    //   icon: "fa-envelope",
    // },
  ];
  return (
    <div className="apropos-page">
      <Header />
      {/* Hero Section */}
      <div
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1 className="hero-title">À propos</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item"><a href="/">Accueil</a></li>
                  <li className="breadcrumb-item active" aria-current="page">À propos</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* About Introduction Section */}
      <section className="about-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">
                L'Association Burkinabè des Inventeurs et Innovateurs (AB2i)
              </h2>
              <div className="section-divider"></div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-content">
                <p className="about-lead">
                  L'Association Burkinabè des Inventeurs et Innovateurs (AB2i) est une association professionnelle,
                  apolitique et non confessionnelle.
                </p>
                <p>
                  Elle est créée en 2013 conformément à la loi n°10/92/ADP du 15 décembre 1992 portant liberté d'association.
                  Elle a été officiellement reconnue par les autorités le 20 décembre 2013
                  sous le récépissé N°2013 001492 /MATS/SG/DGLP/DOSOC.
                </p>
                <div className="feature-row">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <i className="fas fa-star"></i>
                    </div>
                    <div className="feature-text">
                      <h5>Innovation</h5>
                      <p>Nous promouvons l'innovation technologique au Burkina Faso</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <div className="feature-text">
                      <h5>Développement</h5>
                      <p>Nous contribuons à l'émergence économique et technologique</p>
                    </div>
                  </div>
                </div>

                <div className="experience-badge-container">
                  <div className="experience-badge">
                    <span className="experience-years">10+</span>
                    <span className="experience-text">Années d'expérience</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-image">
                <img src="assets/img/logo/ab2i.jpg" alt="AB2i Logo" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Information Cards Section */}
      <section className="info-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">Nos informations clés</h2>
              <div className="section-divider"></div>
              <p className="section-lead">
                Découvrez nos objectifs, missions et domaines d'expertise pour le développement du Burkina Faso
              </p>
            </div>
          </div>

          <div className="row g-4">
            {keyInfoCards.map((card, index) => (
              <div className="col-lg-6 mb-4" key={index}>
                <div className="info-card">
                  <div className="info-card-header">
                    <div className="info-card-icon">
                      <i className={`fas ${card.icon}`}></i>
                    </div>
                    <h3 className="info-card-title">{card.title}</h3>
                  </div>
                  <div className="info-card-body">
                    <ul className="info-card-list">
                      {card.content.map((item, idx) => (
                        <li key={idx}>
                          <i className="fas fa-check"></i>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

     {/* Bureau Members Section */}
<section className="bureau-members-section">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center mb-5">
        <h2 className="section-title">Les Membres du Bureau</h2>
        <div className="section-divider"></div>
        <p className="section-lead">
          Découvrez l'équipe dirigeante de l'Association Burkinabè des Inventeurs et Innovateurs
        </p>
      </div>
    </div>

    {loading ? (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
        <p className="mt-3">Chargement des membres du bureau...</p>
      </div>
    ) : error ? (
      <div className="alert alert-danger text-center" role="alert">
        <i className="fas fa-exclamation-triangle me-2"></i>
        {error}
        <p className="mt-2 mb-0">Veuillez réessayer plus tard ou contacter l'administrateur.</p>
      </div>
    ) : (
      <div className="row g-4">
        {bureauMembers.length > 0 ? (
          bureauMembers.map((member, index) => {
            const imageUrl = member.image
              ? `${baseApiUrl.defaults.baseURL}/image/${member.image}`
              : "assets/img/profiles/avatar-01.jpg";

            return (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <div className="member-card">
                  <div className="member-image">
                    <img
                      src={imageUrl}
                      alt={`${member.prenom} ${member.nom}`}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="member-info">
                    <h4 className="member-name">{member.prenom} {member.nom}</h4>
                    <p className="member-position">{member.poste}</p>
                    <div className="member-contact">
                      {member.telephone && (
                        <a href={`tel:${member.telephone}`} className="contact-link">
                          <i className="fas fa-phone"></i> {member.telephone}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-12 text-center">
            <p>Aucun membre du bureau disponible pour le moment.</p>
          </div>
        )}
      </div>
    )}
  </div>
</section>

      {/* Vision and Values Section */}
      <section className="vision-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">Notre vision</h2>
              <div className="section-divider"></div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="vision-content">
                <p className="vision-lead">
                  L'AB2i aspire à un Burkina Faso où les inventeurs et innovateurs contribuent
                  significativement au développement économique et social du pays.
                </p>
                <p>
                  Nous travaillons à créer un environnement propice à l'innovation,
                  qui favorise le développement et la mise en œuvre de solutions technologiques
                  adaptées aux besoins locaux.
                </p>

                <div className="progress-container">
                  <div className="progress-item">
                    <div className="progress-header">
                      <span>Innovation</span>
                      <span>85%</span>
                    </div>
                    <div className="progress-bar-container">
                      <div className="progress-bar-fill" style={{ width: "85%" }}></div>
                    </div>
                  </div>

                  <div className="progress-item">
                    <div className="progress-header">
                      <span>Développement rural</span>
                      <span>90%</span>
                    </div>
                    <div className="progress-bar-container">
                      <div className="progress-bar-fill progress-bar-yellow" style={{ width: "90%" }}></div>
                    </div>
                  </div>

                  <div className="progress-item">
                    <div className="progress-header">
                      <span>Transfert de technologies</span>
                      <span>75%</span>
                    </div>
                    <div className="progress-bar-container">
                      <div className="progress-bar-fill progress-bar-orange" style={{ width: "75%" }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="values-container">
                <h3 className="values-title">Nos valeurs</h3>
                <div className="values-grid">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-handshake"></i>
                    </div>
                    <h4>Solidarité</h4>
                    <p>Entraide entre les membres pour le progrès collectif</p>
                  </div>

                  <div className="value-item">
                    <div className="value-icon value-icon-yellow">
                      <i className="fas fa-lightbulb"></i>
                    </div>
                    <h4>Créativité</h4>
                    <p>Encourager l'innovation adaptée aux besoins locaux</p>
                  </div>

                  <div className="value-item">
                    <div className="value-icon value-icon-orange">
                      <i className="fas fa-users"></i>
                    </div>
                    <h4>Inclusion</h4>
                    <p>Accessibilité des technologies à toutes les populations</p>
                  </div>

                  <div className="value-item">
                    <div className="value-icon">
                      <i className="fas fa-globe-africa"></i>
                    </div>
                    <h4>Durabilité</h4>
                    <p>Des solutions respectueuses de l'environnement</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section
      <section className="cta-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h3 className="cta-title">Rejoignez l'AB2i aujourd'hui</h3>
              <p className="cta-text">Ensemble, innovons pour un Burkina Faso meilleur</p>
            </div>
            <div className="col-lg-4 text-lg-end">
              <a href="/contact" className="cta-button">Nous contacter</a>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
}

export default Apropos;
